import { ExtendedRegex } from "../text/ExtendedRegex";
import { Lexer } from "../text/lexer/Lexer";
import { LexerMatcher } from "../text/lexer/LexerMatcher";

export type COMPOUND = "COMPOUND";
export type SPACE = "SPACE";

export type SVGTextLexerType = COMPOUND | SPACE;

export class SVGTextLexer extends Lexer
{
  static readonly COMPOUND:COMPOUND = "COMPOUND";
  static readonly SPACE:SPACE = "SPACE";

  static readonly compoundMatcher = new LexerMatcher( 
    SVGTextLexer.COMPOUND, ExtendedRegex.create( /\S+/ )
  );

  static readonly spaceMatcher = new LexerMatcher( 
    SVGTextLexer.SPACE, ExtendedRegex.create( /./ )
  );

  constructor()
  {
    super();
    this._create();    
  }

  _create()
  {
    this.addMatcher( SVGTextLexer.compoundMatcher );
    this.addMatcher( SVGTextLexer.spaceMatcher );
  }
}